import { Component } from '@angular/core';
import Check from 'framework/Check';
import permissions from 'app/models/Permissions';
import { TabPanelDisplayMode } from 'app/components/enums/TabPanelDisplayMode';
import Utils from '../../../shared/utils';

@Component({
  selector: 'app-components-managecustomer-customerworkhistory',
  templateUrl: './CustomerWorkHistory.component.html'
})
export class CustomerWorkHistoryComponent {
  public customer: Boo.Objects.Customer;
  partner: Boo.Objects.Partner;
  user: Boo.Objects.User;
  public showWorkflowTaskHistoryTab = false;
  public canViewPendingWork = false;
  public tabPanelDisplayMode = TabPanelDisplayMode;

  public canActivate(user: Boo.Objects.User, partner: Boo.Objects.Partner, params: any): boolean {
    Check.isNotEmpty(params, 'Params is empty');
    Check.isNotEmpty(params.customer, 'Customer is missing');

    this.showWorkflowTaskHistoryTab = _.any(user.PartnerUsers, x => x.PartnerId === Boo.Objects.Enums.PartnerEnum.Boostability);
    this.canViewPendingWork = Utils.hasPermission(partner, user.PartnerUsers, permissions.CanViewCustomerPendingWork, user);

    this.customer = ko.mapping.toJS(params.customer);
    this.partner = partner;
    this.user = user;

    return true;
  }
}
